import { map } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { Observable } from 'rxjs'

import { CreateRequest, AccountValidationResult } from '../models/account';

import { environment } from '../../../environments/environment';

const registerUrl = '/auth/register'
const validateUrl = '/auth/validate-customer'
const forgotUrl = '/auth/forgot'
const resetUrl = '/auth/reset'
const activateUrl = '/auth/activate'
const validateResetPasswordUrl = '/auth/reset-link-validation'
const resetAccountLanguage = '/auth/reset-account-language'
const verifyEmailUrl = '/auth/verify-email'

@Injectable()
export class AccountService {
    constructor(
        private http: HttpClient
    ) { }

  validateCustomer(request: CreateRequest) {
    return this.http.post<any>(
        environment.baseApiUrl + validateUrl,
        {
          customerCode: request.customerCode,
          zipCode: request.postalCode
        }
    ).pipe(map(val => true))
  }

  createAccount(request: CreateRequest) {
    return this.http.post<any>(
      environment.baseApiUrl + registerUrl,
      request
    )
  }

  initForgot(email: string) {
    return this.http.post<any>(
      environment.baseApiUrl + forgotUrl,
      { email }
    )
  }

  resetPassword(token: string, newPassword: string) {
    return this.http.post<any>(
      environment.baseApiUrl + resetUrl,
      { uuid: token, password: newPassword }
    )
  }

  activateAccount(token: string): Observable<any> {
    let params = new HttpParams().set('uuid', token)

    return this.http.get<any>(
      environment.baseApiUrl + activateUrl,
      { params }
    )
  }

  validateResetPassordLink(token: string): Observable<boolean> {
    return this.http.post<any>(
      environment.baseApiUrl + validateResetPasswordUrl,
      { uuid: token }
    )
  }

  getUserLanguage(uuid: string): Observable<string> {
    return this.http.post<any>(
      environment.baseApiUrl + resetAccountLanguage,
      { uuid }
    )
  }

  verifyEmail(userId: string): Observable<AccountValidationResult> {
    return this.http.put<AccountValidationResult>(
      `${environment.baseApiUrl}${verifyEmailUrl}`, {
        userId: userId
      }
    )

  }
}
